import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from '@blueprintjs/core'
import { useScreenshotMode } from '../../hooks/useScreenshotMode'
import { axiosGet } from '../../util/api'
import classNames from 'classnames'
import { StateIndicatorForListItems } from '../badge/SmallBadge'
import { Popover } from '../ui/popover'
const DisplayLimit = 10
export const TotalPromotionsNames = ({ item, className = '', onlyEnabled = false }) => {
    const [promotions, setPromotions] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [loading, setLoading] = useState(false)
    const screenshotMode = useScreenshotMode()

    useEffect(() => {
        setPromotions([])
        setLoading(false)
        setLoaded(false)
    }, [item])

    const loadPromotions = useCallback(() => {
        if (loaded) {
            return
        }

        setLoading(true)
        let uri = `products/${item.asin}/getPromotions`
        if (onlyEnabled) {
            uri += `?enabled=true`
        }
        const promise = axiosGet(uri)

        promise
            .then((res) => {
                setLoading(false)
                setLoaded(true)
                setPromotions(Object.values(res.data))
            })
            .catch((res) => {
                setLoading(false)
                setLoaded(true)
                console.log('res is', res)
            })
    }, [item, loaded])

    return (
        <PromotionNamesPure
            className={className}
            loading={loading}
            loaded={loaded}
            loadPromotions={loadPromotions}
            promotions={promotions}
            item={item}
            onlyEnabled={onlyEnabled}
            screenshotMode={screenshotMode}
        />
    )
}

class PromotionNamesPure extends React.PureComponent {
    render() {
        const {
            loading,
            loaded,
            className,
            loadPromotions,
            promotions,
            item,
            onlyEnabled,
            screenshotMode,
        } = this.props

        let count = 0
        if (onlyEnabled) {
            count = item?.active_promotions
        } else {
            count = item?.total_promotions
        }
        if (count !== undefined) {
            if (count === 0) {
                return 0
            }

            return (
                <Popover
                    position="bottom"
                    interactionKind="hover"
                    onOpening={loadPromotions}
                    className={classNames(className)}
                    content={
                        <div
                            className={classNames('p-2', { blur: screenshotMode })}
                            style={{ maxWidth: '350px' }}
                        >
                            {loading && <Spinner />}
                            {loaded && <RenderPromotions promotions={promotions} />}
                        </div>
                    }
                >
                    <div>{count}</div>
                </Popover>
            )
        }

        return null
    }
}

const RenderPromotions = ({ promotions }) => {
    const navigate = useNavigate()
    const promoNameListItems = []

    for (let i = 0; i < promotions.length; i++) {
        if (i == DisplayLimit) {
            break
        }

        const promotion = promotions[i]
        promoNameListItems.push(
            <div
                key={i}
                className={
                    'relative inline-block h-5 flex justify-start items-start text-xs rounded text-left'
                }
            >
                <StateIndicatorForListItems top={5} left={-5} value={promotion.enabled ? 1 : 2} />
                <span
                    onClick={() => navigate(`../smart-campaigns/${promotion.id}`)}
                    className={'pl-2 cursor-pointer hover:underline'}
                >
                    {promotion.name}
                </span>
            </div>,
        )
    }

    if (promotions.length > DisplayLimit) {
        const rest = promotions.length - DisplayLimit
        promoNameListItems.push(
            <div key={promotions.length} className="text-gray-500 text-xs">
                ...and {rest} more not shown
            </div>,
        )
    }

    return <div>{promoNameListItems}</div>
}
